'use client'
import Stack from '@mui/material/Stack'
import { FC } from 'react'

import Pill from '@/components/Pill'

const LogixboardCaseStudyStats: FC<{}> = () => {
    return (
        <Stack
            direction={{
                xs: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
            }}
            spacing={{
                xs: 1,
                sm: 1,
                md: 3,
                lg: 3,
                xl: 3,
            }}
        >
            <Pill
                header={'ADOPTION'}
                title={'30+ paying customers'}
                backgroundImageSrc={'/images/logixboard-case-study/logixboard-stat-adoption.png'}
            />
            <Pill
                header={'USAGE'}
                title={'1.1+ million shipments'}
                backgroundImageSrc={'/images/logixboard-case-study/logixboard-stat-usage.png'}
            />
        </Stack>
    )
}

export default LogixboardCaseStudyStats
